import styled from "styled-components";

export const StyledIframe = styled.iframe`
  position: "absolute";
  top: 0;
  left: 0;
`;
